module.exports = __webpack_public_path__ + "static/img/loading.3af007a5.svg";